
addEventListener('DOMContentLoaded', () => {

	if(document.querySelector('.arrow_left')){
		//homepage carousel products (only 4)
		let products = document.querySelectorAll('.products_images .product');
		let productsContainer = document.querySelector('.category');
		let arrowLeft = document.querySelector('.arrow_left');
		let arrowRight = document.querySelector('.arrow_right');
		let productsContainerScroll = (products[0].offsetWidth + 20);
		// productList.style.transform = "translateX(-"+305*productListSteps+"px)"
		let maxScrollLeft = productsContainer.scrollWidth - productsContainer.clientWidth;
		
		productsContainer.scrollLeft = 0;
		arrowLeft.style.display = "none";
	
		arrowRight.addEventListener('click', function(){
	
			productsContainer.scrollLeft += productsContainerScroll;
	
			setTimeout(() => {
				if(productsContainer.scrollLeft > 0 ){
					arrowLeft.style.display = "block";
				}
	
				if(productsContainer.scrollLeft == maxScrollLeft){
					arrowRight.style.display = "none";
				}
				
			}, 400);
		})
		arrowLeft.addEventListener('click', function(){
	
			if(productsContainer.scrollLeft > 0) {
				productsContainer.scrollLeft -= productsContainerScroll;
			}
			if(productsContainer.scrollLeft <= productsContainerScroll){
				arrowLeft.style.display = "none";
			}
	
			setTimeout(() => {
				if(productsContainer.scrollLeft > 0 ){
					arrowRight.style.display = "block";
				}
				
			}, 200);
		})
	
	}


	// Change product order quantities
	const bmins = document.querySelectorAll('.shop .btn-min')
	bmins.forEach(bmin => {
		bmin.addEventListener('click', function (e) {
			e.preventDefault()
			changeQuantity(this.parentElement.querySelector('.quantity'), -1)
		}, false)
	})

	const bpluss = document.querySelectorAll('.shop .btn-plus')
	bpluss.forEach(bplus => {
		bplus.addEventListener('click', function (e) {
			e.preventDefault()
			changeQuantity(this.parentElement.querySelector('.quantity'), 1)
		}, false)
	})

	var changeQuantity = function (input, change) {
		let q = parseInt(input.value) + change
		q = Math.min(Math.max(q, (input.min || 0)), (input.max || Number.MAX_SAFE_INTEGER))
		input.value = q
	}

	// Do some basic checks before putting products in the shoppingcart
	const buttons = document.querySelectorAll('.shop .btn-order')
	buttons.forEach(button => {
		button.addEventListener('click', function (e) {
			e.preventDefault()

			var error = false;
			const dishes = this.parentElement.parentElement.querySelectorAll('.texts select')
			dishes.forEach(dish => {
				if (!error) {
					if (dish.value == 0) {
						error = true
					}
				}
			})

			if (error) {
				alert('U bent een gerecht vergeten te selecteren')
				return
			}

			this.parentElement.parentElement.parentElement.submit();
		}, false)
	})

	var family = false
	document.querySelector('.shop .customer .gender')?.addEventListener('change', function (e) {
		family = (e.target.value == 'family')
		if (family) {
			document.querySelector('.shop .customer #firstname').placeholder = 'Voornaam (optioneel)'
		}
		else {
			document.querySelector('.shop .customer #firstname').placeholder = 'Voornaam'
		}
	})

	//Check all fields als submit
	document.querySelector('.shop .checkout button')?.addEventListener('click', function (e) {
		e.preventDefault()

		const fieldIds = [
			'#firstname',
			'#lastname',
			'#email',
			'#phone',
			'#address',
			'#postalcode',
			'#city',
			'#agree'
		]

		var error = false
		fieldIds.forEach(fieldId => {
			const field = document.querySelector(fieldId)
			console.log(field, field.value)
			if (field.value.trim().length < 1 && field.checked == false && !(family && fieldId == '#firstname')) {
				field.classList.add('error')
				error = true
			}
			else {
				field.classList.remove('error')
			}
		})

		if (error) {
			e.preventDefault()
			alert('Vul de verplichte velden in en ga akkoord met het verwerken van uw gegevens.')
			return false
		}

		this.parentElement.parentElement.parentElement.submit();

	}, false)

})
